// extracted by css-extract-rspack-plugin
export default {"placeholder":"UbfxB","blink":"SvZak"};